import React from 'react'
import styled from 'styled-components'
import { GatsbyImage, StaticImage } from "gatsby-plugin-image"
import { Link } from 'gatsby'

const MainWrapper = styled.div`
position: relative;
    width: 100%;
    .gatsby-image-wrapper {
        width: 100%;
        user-select: none;
        height: 828px;
        filter: brightness(0.75);
        @media screen and (max-width: 600px) {
            height: 1200px;
        }
    }
`
const ImageText = styled.div`
`
const Text = styled.h1`
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    position: absolute;
    top: 3rem;
    text-align: center;
    color: white;
    font-size: 88px;
    /* @media screen and (max-width:740px) {
    margin-left: 16px;
    margin-right: 16px;
    } */
    span {
        color : #FF4C55;
    }
    @media screen and (max-width:465px) {
        bottom: 1rem;
    }
`
const TextH1 = styled.div`
    text-align: center;
    /* &::after {
    content: '';
    position: absolute;
    width: 100%;
    left: 0;
    bottom: 10rem;
    height: 8px;
    border-radius: 30px;
    background-color: #FF4C55;
    @media screen and (max-width:528px) {
        bottom: 12rem;
        height: 7px;
    }
    @media screen and (max-width:465px) {
        bottom: 13rem;
          height: 4px;
    }
    } */
    @media screen and (max-width:1050px) {
        font-size: 75px;
    }
    @media screen and (max-width:560px) {
        font-size: 70px;
    }
    @media screen and (max-width:528px) {
        font-size: 60px;
    }
    /* @media screen and (max-width:465px) {
        font-size: 40px;
    } */
`
const Paragraph = styled.p`
font-weight: 300;
    font-size: 32px;
    line-height: 36px;
    color: white;
    padding: 0 1rem;
    position: relative;
    /* @media screen and (max-width:1050px) {
        font-size: 21px;
    } */
    @media screen and (max-width:528px) {
        bottom: -3rem;
    }
    @media screen and (max-width:465px) {
        top: 1rem;
    }
`
const StartButton = styled(Link)`
background: #FF4C55;
    border-radius: 60px;
    font-family: 'Outfit';
    font-style: normal;
    border: 0;
    font-weight: 400;
    font-size: 20px;
    line-height: 20px;
    padding: 20px 63px;
    position: relative;
    text-align: center;
    color: #FFFFFF;
    bottom: -1rem;
    cursor: pointer;
    @media screen and (max-width:465px) {
        bottom: 2rem;
    }
    @media screen and (max-width:528px) {
        width: 100%;
    }

`
const Description = styled.div`
display: flex;
flex-direction: row;
gap:50px;
margin-top: -1rem;
@media screen and (max-width: 600px) {
    flex-direction: column;
    gap:0;

}
@media screen and (max-width:450px) {
    margin-bottom: 4rem;
}
`
const Experts = styled.div`
    display: flex;
    flex-direction: row;
    gap:1rem;
    align-items: center;
    @media screen and (max-width: 450px) {
        height: 120px;
    }
`
const Experience = styled.div`
    display: flex;
    flex-direction: row;
    gap:1rem;
`
const Ideas = styled.div`
display: flex;
    flex-direction: row;
    gap:1rem;
`
const Number = styled.h1`
    font-family: 'Outfit';
font-style: normal;
font-weight: 300;
font-size: 64px;
line-height: 81px;
/* identical to box height */

text-align: center;

/* White */

color: #FFFFFF;
`
const TextNumber = styled.h4`
    font-family: 'Outfit';
font-style: normal;
font-weight: 400;
font-size: 14px;
line-height: 23px;
/* or 164% */
text-align: start;
letter-spacing: 0.08em;
text-transform: uppercase;

/* White */

color: #FFFFFF;

`
interface MainProps {
    main: any
    image : any
}

const Main: React.FC<MainProps> = ({main,image}) => {
    let location = ''
    let str = ''
    if( typeof window !== 'undefined')
    {
        location = window.location.pathname
        str = location.replace(/^\/([^\/]*).*$/, '$1')
    }
        return (
         <MainWrapper>
                <GatsbyImage image={image.image.gatsbyImageData} alt='Main' />
                <ImageText>
                    <Text>
                    {location == '/' ? 
                        <TextH1>The <span>co-pilot <br /></span> of your digital business</TextH1>
                    :
                        <TextH1>Le <span>copilote </span> de votre <br /> commerce digital</TextH1>
                    }
                        <Paragraph>
                        {location == '/' ? 
                         "Our mission is to make your e-commerce essential"
                      
                    :
                    "Notre mission est de rendre votre e-commerce incontournable"
                    }
                        </Paragraph>
                        <Description>
                            <Experts>
                                <Number>
                                    3
                                </Number>
                                {location == '/' ?
                                (
                                <TextNumber>
                                    
                                Experts<br/> in team
                                </TextNumber>
                                ):
                                (
                                    <TextNumber>
                                    
                                Experts<br/> dans l'équipe
                                </TextNumber>
                                )
                                }
                                
                            </Experts>
                            <Experts>
                                <Number>
                                    12
                                </Number>
                                {location == '/' ?
                                (
                                <TextNumber>
                                    
                                Years of <br/>Experience
                                </TextNumber>
                                ):
                                (
                                    <TextNumber>
                                    
                                    Années <br/> d'expérience
                                </TextNumber>
                                )
                                }

                            </Experts><Experts>
                                <Number>
                                    5{''}
                                </Number>
                                {location == '/' ?
                                (
                                <TextNumber>
                                    
                                    {''}Ideas per <br/>minute
                                </TextNumber>
                                ):
                                (
                                    <TextNumber>
                                    
                                    {''} Idées par <br/>minute
                                </TextNumber>
                                )
                                }
                               
                            </Experts>
                        </Description>
                        <div>
                        <StartButton to={str =='fr-fr' ? '/fr-fr/nos-contacter' : '/contact'} className='pink'>
                        {str =='fr-fr' ? "J'ai un projet" : "Start project"}
                        </StartButton>
                        </div>
                      
                    </Text>
                    
                </ImageText>
            </MainWrapper>
        );
}
export default Main
